module.exports = __webpack_public_path__ + "static/webbyAwd-8d5a738c010c6c77159ec2ba1e08eb81.jpg";